import { useCallback, useRef, useState } from 'react';
import { dialogs } from '@yola/ws-sdk';

const useDialogPosition = ({ element, initialOffsetX, initialOffsetY }) => {
  const modalRef = useRef(null);
  const isModalReadyRef = useRef(false);
  const [offset, setOffset] = useState({ x: initialOffsetX, y: initialOffsetY });

  const calculatePositionOnReady = useCallback(() => {
    if (!modalRef.current || !element || (initialOffsetX && initialOffsetY)) {
      return;
    }

    if (isModalReadyRef.current) {
      return;
    }

    const {
      modal: { width: modalWidth, height: modalHeight },
    } = modalRef.current.state;
    const { offsetX, offsetY } = dialogs.helpers.getPositionByElement(
      element,
      modalWidth,
      modalHeight
    );

    setOffset({ x: offsetX, y: offsetY });
  }, [element, initialOffsetX, initialOffsetY]);

  const handleModalReady = useCallback(() => {
    calculatePositionOnReady();
    isModalReadyRef.current = true;
  }, [calculatePositionOnReady]);

  const handleModalDragEnd = useCallback((_, { x, y }) => {
    setOffset({ x, y });
  }, []);

  return {
    modalRef,
    modalOffset: offset,
    onModalReady: handleModalReady,
    onModalDragEnd: handleModalDragEnd,
  };
};

export default useDialogPosition;
